import { connect } from 'react-redux';
import { isSamlEnabled, isUsingSSO } from 'selectors/session';

import SessionExpiredDialog from './SessionExpiredDialog';

const mapStateToProps = state => ({
  isOpen: state.reloginDialog.isOpen && isUsingSSO(state),
  isSamlEnabled: isSamlEnabled(state),
});

export default connect(mapStateToProps)(SessionExpiredDialog);
